// extracted by mini-css-extract-plugin
module.exports = {"micro":"micro___U-7El"};